import script from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceDeleteModal.vue?vue&type=style&index=0&id=22b97c26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b97c26"]])

export default __exports__